import React from "react";

export default function Logo({ className = "" }) {
  return (
    <a href="/" className={`flex items-center gap-2.5 ${className}`} data-testid="founding-logo">
      <img
        src="https://customer-assets.emergentagent.com/job_site-creator-2220/artifacts/g859gcm8_bHyyve%20Icon.png"
        alt="bHyyve"
        className="w-9 h-9 rounded-lg"
      />
      <span className="text-xl font-bold tracking-tight text-bhyyve-ink font-heading">
        bHyyve
      </span>
    </a>
  );
}
